"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-7fb36760"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("td", { class: "bg-gray summary-label-cell" }, "スケジュール期間", -1 /* HOISTED */));
const _hoisted_2 = ["colspan"];
const _hoisted_3 = ["colspan", "onClick"];
const _hoisted_4 = { class: "bg-gray text-gray" };
const _hoisted_5 = {
    key: 1,
    class: "bg-gray text-gray"
};
const _hoisted_6 = {
    key: 2,
    class: "bg-gray text-gray"
};
const _hoisted_7 = {
    key: 3,
    class: "bg-gray text-gray"
};
const _hoisted_8 = {
    key: 4,
    class: "bg-gray text-gray"
};
const vue_3 = require("vue");
const common_1 = require("../../../common/common");
const LockIcon_vue_1 = __importDefault(require("../../../vue/icons/LockIcon.vue"));
const UnlockIcon_vue_1 = __importDefault(require("../../../vue/icons/UnlockIcon.vue"));
const provider_1 = require("../../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryTableScheduleRowView',
    props: {
        scheduleIntervals: {},
        dates: {},
        stats: {},
        branchSettings: {}
    },
    setup(__props) {
        const summaryTablePresenter = (0, vue_3.inject)(provider_1.summaryTablePresenterInjectKey);
        const props = __props;
        const schedulePaddingCellProps = (0, vue_3.computed)(() => {
            const firstInterval = props.scheduleIntervals[0];
            const firstDateStr = props.dates[0];
            if (!firstInterval || !firstDateStr) {
                return {
                    show: false,
                };
            }
            let firstDate;
            try {
                firstDate = (0, common_1.dateFromString)(firstDateStr, "utc");
            }
            catch {
                return {
                    show: false,
                };
            }
            const msDiff = firstInterval.startDate.getTime() - firstDate.getTime();
            if (msDiff < 0) {
                return {
                    show: props.branchSettings?.memoSummary ?? false,
                    colSpan: props.branchSettings?.memoSummary ? 1 : 0
                };
            }
            const dayDiff = Math.round(msDiff / common_1.DAY_MS);
            return {
                show: true,
                colSpan: props.branchSettings?.memoSummary ? dayDiff + 1 : dayDiff,
            };
        });
        const intervalCells = (0, vue_3.computed)(() => {
            const today = new Date();
            const todayUtc = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), 0, 0, 0, 0));
            return props.scheduleIntervals.map((interval, i) => {
                const colSpan = calculateColSpan(interval);
                const isIntervalContainsToday = interval.startDate <= todayUtc && interval.endDate >= todayUtc;
                // Shift this interval back by one period and check whether today falls
                // inside that shifted-back range. This determines adjacency to today
                // without assuming `scheduleIntervals` contains every interval since
                // today (it may only contain the intervals overlapping the currently
                // viewed date range, with a gap before today's actual interval).
                const previousIntervalStart = new Date(interval.startDate);
                let previousIntervalEnd = new Date(interval.endDate);
                if (props.branchSettings?.scheduleCustomEnabled) {
                    previousIntervalStart.setDate(previousIntervalStart.getDate() - props.branchSettings.scheduleLength);
                    previousIntervalEnd.setDate(previousIntervalEnd.getDate() - props.branchSettings.scheduleLength);
                }
                else {
                    previousIntervalStart.setMonth(previousIntervalStart.getMonth() - 1, 1);
                    previousIntervalEnd = new Date(previousIntervalStart.getFullYear(), previousIntervalStart.getMonth() + 1, 0);
                }
                const isIntervalImmediatelyAfterToday = previousIntervalStart <= todayUtc && previousIntervalEnd >= todayUtc;
                let text = "";
                let bgColor = "";
                switch (true) {
                    case isIntervalContainsToday:
                        text = "現在";
                        bgColor = interval.isLocked ? "#9EC6D6" : "#FA7A7A";
                        break;
                    case interval.endDate < todayUtc:
                        text = "完了";
                        bgColor = "#c8d4d9";
                        break;
                    default:
                        text = "予定";
                        bgColor = isIntervalImmediatelyAfterToday ? "#6F7C84" : "#C7D3DA";
                        break;
                }
                if (colSpan !== undefined) {
                    if (colSpan >= 2) {
                        text += text === "現在" ? "の期間" : "期間";
                    }
                    if (colSpan > 2) {
                        text += interval.isLocked ? "（ロック済み）" : "（ロック解除）";
                    }
                }
                return {
                    interval,
                    index: i,
                    colSpan,
                    text,
                    bgColor,
                    isIntervalContainsToday,
                };
            });
        });
        function calculateColSpan(interval) {
            let firstTableDate;
            let lastTableDate;
            try {
                firstTableDate = (0, common_1.dateFromString)(String(props.dates[0]), "utc");
                lastTableDate = (0, common_1.dateFromString)(String(props.dates.at(-1)), "utc");
            }
            catch {
                return;
            }
            const clampedStart = firstTableDate > interval.startDate ? firstTableDate : interval.startDate;
            const clampedEnd = lastTableDate < interval.endDate ? lastTableDate : interval.endDate;
            const msDiff = clampedEnd.getTime() - clampedStart.getTime();
            return Math.max(0, Math.round(msDiff / common_1.DAY_MS) + 1);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                _hoisted_1,
                (0, vue_2.createCommentVNode)(" td for padding in case scheduleStartDate is later than the actual start date "),
                (schedulePaddingCellProps.value.show && schedulePaddingCellProps.value.colSpan)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                        key: 0,
                        colspan: schedulePaddingCellProps.value.colSpan
                    }, null, 8 /* PROPS */, _hoisted_2))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(intervalCells.value, (intervalCell) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                        colspan: intervalCell.colSpan,
                        style: (0, vue_2.normalizeStyle)({ backgroundColor: intervalCell.bgColor }),
                        class: (0, vue_2.normalizeClass)(["interval-cell", { 'red-icon': !intervalCell.interval.isLocked && !intervalCell.isIntervalContainsToday }]),
                        onClick: ($event) => ((0, vue_2.unref)(summaryTablePresenter)?.toggleScheduleIntervalLock(intervalCell.index))
                    }, [
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(intervalCell.text), 1 /* TEXT */),
                            (intervalCell.interval.isLocked)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(LockIcon_vue_1.default, { key: 0 }))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(UnlockIcon_vue_1.default, { key: 1 }))
                        ])
                    ], 14 /* CLASS, STYLE, PROPS */, _hoisted_3));
                }), 256 /* UNKEYED_FRAGMENT */)),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(_ctx.stats?.roleCounts || [], (_) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_4));
                }), 256 /* UNKEYED_FRAGMENT */)),
                (_ctx.stats?.showEmployeeWorkCountCell)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_5, "－"))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (_ctx.stats?.showEmployeeVacationCountCell)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_6, " － "))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (_ctx.stats?.showEmployeePTOCountCell)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_7, "－"))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (_ctx.stats?.showEmployeeLaborCountCell)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_8, "－"))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
